import { FC } from 'react';

import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

const SKELETON_COUNT = 6;

interface SubmissionsTableSkeletonProps {
  className?: string;
}

export const SubmissionsTableSkeleton: FC<SubmissionsTableSkeletonProps> = ({
  className,
}: SubmissionsTableSkeletonProps) => (
  <div className={cn('space-y-6', className)}>
    <Skeleton className='h-8 w-48' />
    <div className='border-primary overflow-hidden rounded-2xl border bg-white shadow-sm'>
      <div className='space-y-3 p-5'>
        {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
          <Skeleton
            key={index}
            className='h-12 w-full'
          />
        ))}
      </div>
    </div>
  </div>
);
